import './WidgetToolbarButton.scss';
import {button, ButtonProps} from '@xh/hoist/desktop/cmp/button';

export function widgetToolbarButton(props: ButtonProps): React.ReactElement<ButtonProps, any> {
    return button({className: 'rzx-widget-toolbar-button', ...props});
}
